const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLightSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 571 380",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9335,-0.00154472,0.00154472,2.9335,554.958,154.899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.831C-13.006,-17.851 -49.211,-47.857 -91.871,-47.857C-134.533,-47.857 -170.739,-17.847 -183.736,23.843C-174.093,6.113 -160.246,-8.579 -143.697,-18.622C-149.202,-9.597 -152.373,1.007 -152.373,12.351C-152.373,43.476 -128.502,69.015 -98.069,71.688C-119.961,67.106 -136.4,47.702 -136.4,24.453C-136.4,9.122 -129.243,-4.53 -118.096,-13.37C-125.538,-4.706 -128.714,7.361 -125.526,19.226C-120.396,38.292 -100.791,49.59 -81.719,44.468C-63.689,39.623 -52.606,21.814 -55.798,3.759C-55.043,17.159 -63.726,29.709 -77.198,33.325C-92.64,37.475 -108.524,28.321 -112.677,12.88C-116.827,-2.564 -107.674,-18.448 -92.227,-22.599C-89.195,-23.416 -86.146,-23.713 -83.172,-23.554C-80.825,-23.314 -78.53,-22.901 -76.295,-22.337C-75.617,-22.13 -74.946,-21.901 -74.287,-21.647C-74.515,-21.768 -74.757,-21.86 -74.987,-21.977C-54.729,-16.25 -39.879,2.36 -39.879,24.453C-39.879,35.103 -43.337,44.94 -49.179,52.921C-39.277,42.283 -33.216,28.028 -33.216,12.351C-33.216,0.27 -36.822,-10.965 -43.002,-20.354C-25.144,-10.308 -10.216,5.059 0,23.831",
    style: {
      fill: "rgb(240,243,251)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightSm);
export default __webpack_public_path__ + "static/media/logo-light-sm.57638835ca73f511ddb8eadf421aaaaf.svg";
export { ForwardRef as ReactComponent };